































































































































































































import Vue from "vue";
import Component from "vue-class-component";
import ErrorMessages from "@/ts/constants/ReportingErrorMessages";
import Datepicker from 'vuejs-datepicker';
import AddressInfo from '@/views/shared/AddressInfo.vue';
import { IVueStateCollection } from "@/ts/FormBuilder";
import { IReportingVueModel } from '@/ts/models/IReportingVueModel';
import func from "@/ts/FormFunctions";

@Component({
    props: {
        form: {
            type: Object as () => IReportingVueModel
        },
        vueStates: {
            type: Object as () => IVueStateCollection
        },
        isReadOnly: {
            type: Boolean
        }
    },
    components: {
        Datepicker, AddressInfo
    }
})
export default class Certification extends Vue {

    name: string = "Certification";
    title: string = "";
    hasAddressError: boolean = true;

    errorMsgs = ErrorMessages;

    mounted(): void {
        this.title = this.$props.vueStates.views[2].name;

        this.$emit("update:title", this.title);
        this.$emit("update:currentIndex", 2);

        if (this.$props.form.signatureDate === "0001-01-01T00:00:00") {
            this.$props.form.signatureDate = new Date();
        }

        this.$props.vueStates.views[2].visited = true;

        this.$watch("hasErrors", (n, o) => {
            this.$props.vueStates.views[2].error = this.hasErrors;
        }, { immediate: true });
    }

    get isFirstNameError(): boolean {
        return func.isNullOrEmpty(this.$props.form.firstName);
    }

    get isLastNameError(): boolean {
        return func.isNullOrEmpty(this.$props.form.lastName);
    }

    get isCompanyNameError(): boolean {
        return func.isNullOrEmpty(this.$props.form.companyName);
    }

    get isPhoneError(): boolean {
        return func.isNullOrEmpty(this.$props.form.phone);
    }

    get isEmailError(): boolean {
        return func.isNullOrEmpty(this.$props.form.email) || !func.isValidEmail(this.$props.form.email);
    }

    get isSignatureError(): boolean {
        return func.isNullOrEmpty(this.$props.form.signature) || this.$props.form.signature.length > 100;
    }

    get signDate(): string {
        let date = new Date(this.$props.form.signatureDate);
        return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
    }

    get hasErrors(): boolean {
        return this.hasAddressError || this.isFirstNameError || this.isLastNameError || this.isCompanyNameError || this.isPhoneError || this.isEmailError || this.isSignatureError;
    }
}

